export default {
  newDesign: true,
  title: "Matematik Krizlerine Son Verin, Eğlenceli Dersle Çocuğunuzu Tanıştırın! | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrMathGr",
    segment: 12,
  },
  startPage: {
    title:
      "Matematik krizlerinden bıktınız mı?",
    subtitle:
      "Sadece 3 dakikada çocuğunuzun matematiği neden sevmediğini keşfedin — ardından sayıları sevmelerine yardımcı olacak Eğlenceli ve Kolay<br><br>Deneme Dersimize hemen katılın!",
    image: {
      url: "/welcome/tr_sp_math_grades_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_sp_math_grades_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Teste Katılın ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "‘Matematik’ lafı geçtiğinde çocuğunuz genellikle nasıl tepki veriyor?",
      answers: [
        "🙈 Elinden geldiğince kaçınıyor",
        "😐 İsteksizce yaklaşıyor",
        "🤔 Deniyor ama kısa sürede ilgisini kaybediyor",
        "🙂 Genellikle seviyor fakat bazen engellerle karşılaşıyor"
      ],
    },
    2: {
      question: "Matematikteki en büyük zorlukları nedir?",
      answers: [
        "❓ Formüller ve kavramlarla ilgili zorlanma",
        "😴 Sıkıcı veya tekrara dayalı bulma",
        "😰 Hata yapmaktan korkma",
        "🏫 Okulda ya da evde yeterince destek bulamama"
      ],
    },
    3: {
      question: "Sizce “matematiği sevmemelerine” en çok ne sebep oluyor?",
      answers: [
        "🙄 İlgi çekici etkinliklerin olmadığı sıkıcı dersle",
        "🚀 Notlar ve sınav baskısı",
        "🤝 Bireysel ilgi eksikliği",
        "⏳ Yetersiz zaman veya rehberlik"
      ],
    },
    4: {
      question: "Matematik ödevi sırasında stres belirtileri görüyor musunuz?",
      answers: [
        "🥺 Evet, üzülüyor veya kaygılanıyor",
        "😬 Ara sıra rahatsız görünüyor",
        "🤷 Nadiren, genelde sorun yok",
        "✅ Hayır, sakin kalıyor"
      ],
    },
    5: {
      question: "Çocuğunuzun matematiği sevmemesinin gerçek nedenini keşfedip, onlara matematiği sevdirme konusunda yardımcı olmak ister misiniz?",
      answers: [
        "✅ Evet, kesinlikle!",
        "🤔 Belki, biraz daha bilgiye ihtiyacım var",
        "🔍 Henüz emin değilim",
        "👀 Sadece seçenekleri araştırıyorum"
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
      title: "Matematikle mücadele etmeye son vermeye hazır mısınız?",
      subtitle: "Ücretsiz deneme dersinizi ayırtarak:<br>• Temel nedeni belirleyin<br>• Stresiz yaklaşımımızı deneyimleyin<br>• Çocuğunuzun nihayet matematiği sevmesine yardımcı olun",
      button: "Ücretsiz Dersinizi Ayırtın",
    },
    7: {
      title: "Çocuğunuzun Yaşını Seçin",
      subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
      type: "age",
      button: "",
    },
    8: {
      question:
        "Çocuğunuzun çalışması için bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "👍 Evet",
        {
          answer: "👎 Hayır",
          stopAnswer: true,
        },
      ],
    },
    9: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Lütfen not edin:<br>• Çalışan bir bilgisayar veya dizüstü gerekli.<br>• Ders sırasında ebeveyn bulunmalı.<br>• Dersler, özgüveni ve matematik başarısını artırmak için kişiselleştirilmiştir.Adım adım matematik zorluklarını aşalım!",
      button: "Sırada ne var?",
    },
    12: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    13: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
